import { Dispatch } from 'redux';
import { organizationStatsOnListen } from '../../api/firebase/stats';
import { STATS_FETCHED } from './types';

export const statsFetched = (stats) => ({
  type: STATS_FETCHED,
  stats,
});

export const startOrganizationStatsListener = (organizationId: string) => (dispatch: Dispatch) => {
  return organizationStatsOnListen(
    organizationId,
    (data) => {
      if (data) dispatch(statsFetched(data));
    },
    (error) => console.log(error.message)
  );
};
